import cn from 'classnames';
import { Circles } from 'react-loader-spinner';

import styles from './styles.module.scss';

const Loader = ({
  show = false,
  className,
  color,
  height,
  width,
  timeout = 10000,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className={cn(styles.wrapper, className)}>
      <Circles
        color={color || 'var(--colors-orange)'}
        height={height || 100}
        width={width || 100}
        timeout={timeout}
      />
    </div>
  );
};

export default Loader;
